<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
button.disabled {
  cursor: no-drop;
}
td button.btn.status {
  cursor: auto;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-md-12 col-sm-12">
        <div class="card bg-primary text-white">
          <div class="row">
            <div class="col-md-9">
              <div class="card-body">
                <div class="mb-3">
                  <h3>{{ detailUser.nama }}</h3>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mb-3">
              <i
                style="    
                  height: 40px;
                  width: 40px;
                  opacity: 0.8;
                  float: right;
                  margin-right: 13px;"
                class="c-sidebar-nav-icon fa fa-user opacity-7"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <CCard>
      <!-- Tabs -->
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Detail Riwayat Peserta RPL
        <Button
          class="btn btn-md btn-success px-4 py-2 ml-auto mr-2"
          @click="createData"
          >Tambah</Button>
        <Button
          class="btn btn-md btn-dark px-4 py-2 text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <div>
        <CCardBody class="mt-3">
          <CRow>
            <CCol lg="12" class="table-responsive">
              <CDataTable
                style="widht:100% !important"
                :items="items"
                :fields="fields"
              >
                <template #no="{index}">
                  <td class="py-2">{{ index += 1 }}</td>
                </template>  

                <template #status_pembayaran="{item}">
                  <td
                    class="py-2 text-success text-left font-weight-bold"
                    v-if="item.status_pembayaran == 'settlement'"
                  >Lunas</td>
                  <td
                    class="py-2 text-purple text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'pending'"
                  >Menunggu Pembayaran</td>
                  <td
                    class="py-2 text-secondary text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'expired'"
                  >Expired</td>
                  <td
                    class="py-2 text-secondary text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'failure'"
                  >Pembayaran Gagal</td>
                  <td
                    class="py-2 text-danger text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 0"
                  >Belum Dibayar</td>
                  <td v-else-if="item.status_bypass == '1'" class="py-2 text-success text-left font-weight-bold">
                    Lunas
                  </td>
                  <td
                    class="py-2 text-danger text-left font-weight-bold"
                    v-else
                  >Belum Lunas</td>
                </template>

                <template #statusbatal="{item}">
                  <td
                    class="py-2 text-success text-center font-weight-bold"
                    v-if="item.statusbatal == 'Disetujui'"
                  > 
                    {{ item.statusbatal }} 
                  </td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else-if="item.statusbatal == 'Ditolak'"
                  > 
                    {{ item.statusbatal }} 
                  </td>
                  <td
                    class="py-2 text-warning text-center font-weight-bold"
                    v-else-if="item.statusbatal == 'Pengajuan'"
                  > 
                    {{ item.statusbatal }} 
                  </td>
                  <td
                    class="py-2 text-secondary text-center font-weight-bold"
                    v-else
                  > 
                    {{ item.statusbatal }} 
                  </td>                
                </template>

                <template #aksi="{item}">
                  <td class="py-2 text-center">
                    <router-link :to="`/rpl/data-peserta/${item.id_sertifikasi_rpl_peserta}`">
                      <CButton v-c-tooltip="'Detail Mata Uji'"  color="info" class="btn-sm" square>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </CButton> &nbsp;&nbsp;
                    </router-link>                   
                  </td>
                </template>

              </CDataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
    </CCard>
    <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <div class="form-group">
               <label for="" class="font-weight-bold">Level</label>
                <multiselect
                  class="mulit-select"
                  label="namaLevel"
                  placeholder="Pilih Level"
                  :show-labels="false"
                  @select="pilihLevel"
                  v-model="formData.level"
                  required
                  id="selectLevel"
                  :options="optionMasterLevel"
                ></multiselect>
              </div>
            </CCol>
            <CCol sm="12 mt-2">
              <label for class="font-weight-bold">Sertifikasi RPL</label>              
              <multiselect
                  class="mulit-select"
                  label="nama_rpl"
                  placeholder="Pilih Sertifikasi RPL"
                  :show-labels="false"
                  @select="getDetailRpl"
                  v-model="formData.sertifikasiRpl"
                  required
                  id="selectRpl"
                  :options="optionMasterRpl"
                ></multiselect>
            </CCol>
            <CCol sm="12 mt-3">
              <table class="table">
                <thead>
                  <tr>
                    <th class="w-75">Mata Uji</th>                    
                    <th>Nilai</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value , index) in dataMataUji" v-bind:key="index">
                    <td class="text-left">{{ value.namaMataUji }}</td>
                    <td><input type="number" min="0" max="100" class="form-control text-center" required v-model="value.nilai"></td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    <!-- End Data Sertifikasi -->
  </div>
</template>
<script>
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service";
import RiwayatPesertaService from '../../../services/sertifikasi/riwayat-peserta.service';
import DataKeanggotaanService from '../../../services/keanggotaan/data-anggota.service';
import MasterRplService from "@/services/rpl/master-rpl.service";
import { Level } from "@/mixins/master/Level";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { PaginationDetailRiwayat } from "../../../mixins/paginationType/PaginationDetailRiwayat";

const fields = [
    { key: 'no', _style: 'width: 1%' },
    {
        key: "nama_rpl",
        label: 'Mata Sertifikasi RPL',
        _style: 'width: 15%'
    },
    {
        key: 'status_pembayaran',
        label: 'Status Pembayaran',
        _style: 'width: 18%; text-align: left'
    },
    {
        key: 'statusbatal',
        label: 'Status Pembatalan',
        _style: 'width: 18%; text-align: center'
    },
    {
        key: "aksi",
        _style: "width:20%; text-align: center",
        sorter: false,
        filter: false
    }
];

export default {
  mixins : [
    AlertUtils,
    PaginationDetailRiwayat,
    Level
  ],
  props : {
    nama_lengkap : String 
  },
  data() {
    
    return {
      modalDetailPembatalan : false,
      items: [],
      dataRpl: [],
      detailUser : {},
      optionMasterRpl : [],
      dataMataUji : [],
      actionPost: "",
      formData: {
        level: '',      
        id_mata_uji_peserta : '',
        id_sertifikasi_peserta : '',
        id_invoice : '',
        kehadiran : '',
        status_kelulusan : '',
        status_mata_uji : '',
        status_pembatalan : '',
        status_refund : '',
        created_at : '',
        status_pembayaran : '',
        nama_mata_uji : '',
        nama_tc : '',
        alamat : '',
        nama_kota_kab : '',
        sesi : '',
        sertifikasiRpl: '',

        idRpl: '',
        idUser: this.$route.params.id_user,
        mataUji : [],
        
        periode: '20201',
      },
      
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getAllLevel();
    this.getDetailUser();
    this.getData(0,10,this.filter,this.$route.params.id_user);
    setTimeout(() => {      
      this.getMasterRpl("0", this.pageSize, "default", this.level.idLevelAnggota);
    }, 1000)
  },
  methods: {
    pilihLevel(value){
      if(value.idLevelAnggota == 'default') {
        this.getMasterRpl("0", this.pageSize, 'default', 'default');
      }      
      this.level = value;
      this.getMasterRpl("0", this.pageSize, 'default', value.idLevelAnggota);
    },

    getDetailUser() {
        DataKeanggotaanService.getDataDiri(this.$route.params.id_user)
        .then(response => {
          this.detailUser = response.data.data[0];
        })
    },

    tutupModal() {
      this.modalDetailPembatalan = false;
    },
    
    getData(currentPage,pageSize,filter,idUser)
    {
      this.idUser = this.$route.params.id_user

      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      RiwayatPesertaService.getDetailRiwayatPesertaRpl(currentPage,pageSize,filter,idUser)
      .then(response => {
          vm.items = response.data.data.content;
          loader.hide();  
      }).catch(error => {
        // comment console console.log(error);
      })
    },

    getMasterRpl(currentPage, pageSize, filter, idLevel) {
      var vm = this;
      MasterRplService.getDataSertifikasiRpl(currentPage, pageSize, filter, idLevel)
        .then(response => {
          vm.optionMasterRpl = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDetailRpl(value) {
      var vm = this;
      vm.formData.idRpl = value.id_sertifikasi_rpl;
      MasterRplService.getDetailDataSertifikasiRpl(value.id_sertifikasi_rpl)
        .then(response => {                    
          vm.dataMataUji = [];
          this.formData.mataUji = [];
          var data = response.data.singleData.sertifikasiRplMataUjiRequest;
          var dataTc = response.data.singleData.sertifikasiRplMataUjiRequestTc;
          if(data.length > 0) {
            data.forEach(el=>{
              vm.dataMataUji.push({
                idMataUji : el.idSertifikasiRplMataUji,
                nilai : '',
                namaMataUji : el.namaMataUji,
                idSesi : 'jalan'
              })
            });

          }

          if(dataTc.length > 0) {
            dataTc.forEach(el=>{
              vm.dataMataUji.push({
                idMataUji : el.idSertifikasiRplMataUji,
                nilai : '',
                namaMataUji : el.namaMataUji,
                idSesi : 'jalan'
              })
            });

          }
          
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = 'insert';      
    },

    postData() {
      this.actionPost == 'insert'
      this.insertData(this.formData);
    },

    insertData(formData) {
      var vm = this;
      vm.formData.idUser = this.$route.params.id_user;
      vm.formData.mataUji = this.dataMataUji
      RiwayatPesertaService.postRiwayatPesertaRpl(formData)
        .then(response => {
          vm.myModal = false;
          vm.alertSuccess();
          this.getData(0,10,this.filter,this.$route.params.id_user);
        })
        .catch(error => {
          vm.alertError(error.response.data.message);
        });
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>